export default __webpack_public_path__ + "static/media/insta-new.20b92392.svg";